import {EXPLORE_MODE, PAPAYA_SLICES} from '../../symbols/papaya.symbols';

export class MainDashboardStateModel {
  activeExploreMode: EXPLORE_MODE;
  activePapayaSlice: PAPAYA_SLICES;
}
